import { SaveClientReportForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';
import { useParams } from 'react-router-dom';

export type SaveClientReportModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: SaveClientReportModalProps) => {
  const params = useParams();
  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Save client report'
      subTitle='Enter details in order to save them to the system.'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <SaveClientReportForm.FC
        id={props.id}
        projectId={params.projectId ?? ''}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
